/* eslint-disable react/jsx-props-no-spreading */
import CategoryTile from '../../molecules/categoryTile';
import SwiperWithArrows from '../../molecules/swiperWithArrows/SwiperWithArrows';
import { Heading } from '../../typography/heading/Heading';
import { Text } from '../../typography/text/Text';
import Title from '../../typography/title';
import mergeClasses from '../../../utils/shallowMerge';
import clsx from 'clsx';
import React, { useMemo, useState } from 'react';
import { Navigation } from 'swiper/modules';
import { SwiperSlide } from 'swiper/react';
import defaultClasses from './CenteredCarousel.module.scss';
import { StylesCustomizer } from '../../molecules/stylesCustomizer';

const CategoriesSectionCenteredCarousel = (props) => {
  const {
    categories,
    label,
    labelStyles,
    title,
    titleStyles,
    customClasses,
    customClassesForCategoryTile,
    tileLayout = 'stacked',
  } = props;
  const [activeIndex, setActiveIndex] = useState(0);
  const styles = mergeClasses(defaultClasses, customClasses);

  const breakpoints = {
    320: {
      spaceBetween: 10,
      slidesPerView: 1.4,
      centeredSlides: true,
      initialSlide: 1,
    },
    680: {
      spaceBetween: 15,
      slidesPerView: 1.39,
      centeredSlides: true,
      initialSlide: 1,
    },
    1120: {
      spaceBetween: 27,
      slidesPerView: 1.4,
      centeredSlides: true,
      initialSlide: 1,
    },
    2560: {
      spaceBetween: 19,
      slidesPerView: 1.97,
      centeredSlides: true,
      initialSlide: 1,
    },
  };

  const LabelText = (variables) => {
    return (
      <Text className={styles.cateogryLabel} as="span" weight="normal" textTransform="uppercase" variables={variables}>
        <span
          dangerouslySetInnerHTML={{
            __html: label,
          }}
        />
      </Text>
    );
  };
  const TitleText = (variables) => {
    return (
      <Heading
        align="center"
        className={styles.categoryHeader}
        as="h1"
        placement="plp"
        textTransform="uppercase"
        weight="light"
        variables={variables}
      >
        <span
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      </Heading>
    );
  };
  const StyledLabelText = StylesCustomizer(LabelText);
  const StyledTitleText = StylesCustomizer(TitleText);

  const categoriesTitle =
    label || title ? (
      <Title className={styles.categoryTitle}>
        {label && <StyledLabelText styles={labelStyles} />}
        {title && <StyledTitleText styles={titleStyles} />}
      </Title>
    ) : null;

  const swiperCategories = useMemo(() => {
    return categories ? (
      <div className={`${styles.popularCategoriesSection}`}>
        <SwiperWithArrows
          modules={[Navigation]}
          breakpoints={breakpoints}
          onSlideChange={(e) => setActiveIndex(e.activeIndex)}
        >
          {categories.map((cat, idx) => {
            const imageMd = cat.imageHeightMd || cat.imageHeightLg;
            const imageSm = cat.imageHeightsm ? cat.imageHeightsm : imageMd;
            return (
              <SwiperSlide key={idx}>
                <CategoryTile
                  style={{
                    '--image-height-lg': cat.imageHeightLg ? `${cat.imageHeightLg}%` : '125%',
                    '--image-height-md': imageMd ? `${imageMd}%` : '125%',
                    '--image-height-sm': imageSm ? `${imageSm}%` : '125%',
                  }}
                  align={cat.contentAlignment}
                  titleLink={cat.categoryUrl}
                  title={cat.teaserText && cat.teaserText}
                  description={cat.teaserDescription}
                  titleStyles={cat.titleStyles}
                  descriptionStyles={cat.descriptionStyles}
                  image={cat.categoryImage}
                  links={cat.subcats && cat.subcats}
                  isFeatured={cat.isFeatured}
                  customClasses={{
                    ...customClassesForCategoryTile,
                    title: styles.title,
                  }}
                  linkObj={cat.categoryUrl}
                  tileLayout={tileLayout}
                />
              </SwiperSlide>
            );
          })}
        </SwiperWithArrows>
      </div>
    ) : null;
  }, [activeIndex]);

  return (
    <div className={clsx(styles.popularCategories)}>
      {categoriesTitle}
      {swiperCategories}
    </div>
  );
};

export default CategoriesSectionCenteredCarousel;
